import { Component, ViewChild } from '@angular/core';
import { HeaderService } from '@app/core/services/header.service';
import { ODataService } from '@app/core/services/odata/odata.service';
import { SortParam } from '@app/core/constants/sort-param';
import { Observable } from 'rxjs';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { TableComponent } from '@shared/components/table/table.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { dashboardColumns } from '@shared/columns/dashboard.columns';
import { odataTableConfig } from '@app/core/config/odata-table-config';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-exceeding-power-limits',
  imports: [
    TableComponent,
    AlertComponent,
    TranslatePipe
  ],
  templateUrl: './dashboard-exceeding-power-limits.component.html',
  styleUrl: './dashboard-exceeding-power-limits.component.css'
})
export class DashboardExceedingPowerLimitsComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  public tableConfig: TableConfig<any> = {
    id: 'table-dashboard-connection-points-exceeding-power-limits',
    columns: dashboardColumns,
    activeColumns: ['dateForPeak', 'meteringPointIdentification', 'connectionPointIdentification', 'meterNumber', 'connectionPointMaxPower', 'connectionPointMaxCurrent', 'peakConvertedQuantity', 'totalPeakConvertedQuantity'],
    ...odataTableConfig,
    fetchOnLoad: true,
    selectable: false,
    serviceCallback: (pageSize: number, page: number, order?: SortParam) => this.search(pageSize, page, order),
  }

  constructor(
    private readonly headerService: HeaderService,
    private readonly oDataService: ODataService,
  ) {
    this.headerService.setTitle('dashboard.query.exceedingpowerlimits.title');
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
    return this.oDataService.dmc.getPaginated(ODataType.exceedingPowerLimits, { pageSize, page, sort });
  }
}
